import { render, staticRenderFns } from "./PlugToSelect.vue?vue&type=template&id=774db1c2"
import script from "./PlugToSelect.vue?vue&type=script&lang=js"
export * from "./PlugToSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports